/**
 * DTO for workspace settings
 */
export interface WorkspaceSettingsDTO {
  workspaceId: number;
  features: {
    lmsEnabled: boolean;
    notificationsEnabled: boolean;
    statisticsEnabled: boolean;
    allowLessonDownloads: boolean;
  };
}

/**
 * Default feature settings
 */
export const DEFAULT_FEATURES = {
  lmsEnabled: true,
  notificationsEnabled: true,
  statisticsEnabled: true,
  allowLessonDownloads: false,
} as const;
